const MEDIA_TYPES = {
  IMAGE: "image",
  VIDEO: "video",
  DOCUMENT: "document",
  BANNER: "banner",
};
export const DEFAULT_PIC_FROM_NAME_ENDPOINT = "https://api.dicebear.com/8.x/initials/svg?fontSize=40&size=40&seed="

export default MEDIA_TYPES;
